import React from "react";
import {useOnOperationExecute} from "@morningtrain/react-resources";
import useAuth from "../hooks/use-auth";

function AuthReaction() {

    const auth = useAuth();

    useOnOperationExecute(() => {
        auth.refresh();
    });

    return null;
}

export default AuthReaction;
